import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Design } from './components';
import { Footer } from 'components';
import useSchema from './useSchema';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: theme.spacing(3)
  },
  footer: {
    flexGrow: 0
  }
}));

const SchemaDesign = () => {
  const schema = useSchema();
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <Design schema={schema} showNav={true} back="/schema/details" />
      </div>
      {!schema.isLoading && schema.schemaObject && (
        <Footer className={classes.footer} />
      )}
    </div>
  );
};

export default SchemaDesign;
